import { Handle, NodeProps, Position, useUpdateNodeInternals } from 'reactflow';
import { MultiButton } from '@evoach/ui-components';
import { useIntl } from 'react-intl';
import { useEffect } from 'react';

import { translateKey, useGlobalStyles } from './base.node';
import { CustomNodeMenu } from './base.nodemenu';

/*
  MultiButton react-flow node for module builder graph canvas
*/

export const MultiButtonNode: React.FC<NodeProps<any>> = (nodeProps: any) => {
  const classes = useGlobalStyles();
  const intl = useIntl();

  const payload = nodeProps.data.state.entry[0].payload;

  const calculateHandlePosition = (handleCount: number, handleIndex: number) =>
    `${(100 / (handleCount + 1)) * (handleIndex + 1)}%`;

  if (!payload.buttonTexts) {
    payload.buttonTexts = [];
    payload.keyTexts = [];
  }

  // update internal position coordinates of handles when changing the number
  // of handles in this node.
  const updateNodeInternals = useUpdateNodeInternals();
  useEffect(() => {
    updateNodeInternals(nodeProps.id);
  }, [nodeProps.id, payload.keyTexts.length, updateNodeInternals]);

  // it is very important to use the translation key for the id
  // as it is used for the .on target in the state machine transition
  // the id defines the "sourceHandle" in moduleUtils
  const sourceHandles = payload.keyTexts?.map(
    (keyText: string, index: number) => (
      <Handle
        id={keyText}
        key={keyText + index}
        className={classes['react-flow__handle']}
        type="source"
        position={Position.Bottom}
        style={{
          left: calculateHandlePosition(payload.keyTexts?.length ?? 1, index),
        }}
      />
    )
  );

  return (
    <>
      <Handle
        type="target"
        position={Position.Top}
        isConnectable={nodeProps.isConnectable}
        className={classes['react-flow__handle']}
      />
      <div
        className={nodeProps.selected ? classes.selectStyletrue : classes.root}
        style={{ width: 280, maxWidth: 280 }}
      >
        <CustomNodeMenu nodeid={nodeProps.id} />
        <MultiButton
          buttonText={translateKey(intl, payload.buttonText)}
          buttonTexts={payload.buttonTexts.map((textkey: string) =>
            translateKey(intl, textkey)
          )}
          keyTexts={payload.keyTexts}
          saveResultTo={payload.saveResultTo}
        />
      </div>
      {sourceHandles}
    </>
  );
};
